<template>
    <div class="light-color-bg position-relative">
        <HeaderMain title="Qui êtes-vous?" :modalActivator="true" @activateModal="(e)=>modalActive=true"></HeaderMain>
        <div class="container-70">
            <selection-box :values="values" v-model="result" @update:modelValue="saveAndContinue('who', JSON.stringify(result.label), result.value)"></selection-box>
        </div>
        <ModalInfo @closeModal="modalActive=false" v-if="modalActive">
            <div v-for="(value, index) in values " :key="index" class="d-flex vertical-center">
                <div class="col-15 no-shrink">
                    <img :src="value.img" class="modal-img"/>
                </div>
                <p class="modal-text ml-20px">{{ value.description }}</p>
            </div>         
        </ModalInfo>
    </div>
</template>
<script>
import HeaderMain from '../components/HeaderMain.vue'
import ModalInfo from '../components/ModalInfo.vue'
import SelectionBox from '../components/SelectionBox.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            modalActive:false,
            values: [
                {
                    img: require('@/assets/images/citoyen.png'),
                    label: 'Un citoyen',
                    value: "/citoyen/choix-calcul",
                    description:"Je réside à Trois-Rivières et je souhaite calculer les émissions de gaz à effet de serre (GES) de mon ménage."
                },
                {
                    img: require('@/assets/images/organisation.png'),
                    label: 'Une organisation',
                    value: "/organisation/domaine-activite",
                    description:"Je suis une organisation et je souhaite calculer mes émissions de gaz à effet de serre (GES) sur 1 an."
                },
                {
                    img: require('@/assets/images/evenement.png'),
                    label: 'Un évènement',
                    value: "/evenement/choix-calcul",
                    description:"Je souhaite calculer les émissions de gaz à effet de serres (GES) de mon évènement."
                   
                },
                {
                    img: require('@/assets/images/touriste.png'),
                    label: 'Un touriste',
                    value: "/touriste/choix-calcul",
                    description:"Je visite Trois-Rivières et je souhaite calculer les émissions de gaz à effet de serres (GES) de mon séjour."
                }
            ]
        }
    },
    methods:{
        clearPreviousForm(){
            sessionStorage.clear()
        }
    }, 
    components: {
        HeaderMain,
        SelectionBox,
        ModalInfo
    },
    mixins:[utils],
    mounted(){
        this.clearPreviousForm()
    }
}
</script>